var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('router-view'),_c('Growler'),_c('Stripe'),_c('CookieYes'),_c('Loading',{staticClass:"global-loading",attrs:{"status":_vm.isLoading,"opacity":1}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }